<div>
    <button mat-icon-button (click)="search()">
        <mat-icon style="color: blueviolet;">refresh</mat-icon>
    </button>

    @if (buypoint && buypoint.code){

    <button mat-icon-button (click)="add()">
        <mat-icon style="color: red;">create_new_folder</mat-icon>
    </button>
    }

    <br>

    <ng-container *ngIf="agents?.length">
    <mat-form-field appearance="outline" class="filter_field">
        <mat-label>Агент</mat-label>
        <mat-select (selectionChange)="applyFilter()" [(ngModel)]="choosenManager" [disabled]="loading" panelClass="panel_width">
            <mat-option>ВСЕ</mat-option>
            <mat-option *ngFor="let agent of agents" [value]="agent === '«Все агенты»' ? '' : agent">{{agent}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="spacer"></div>
    </ng-container>

    <ng-container *ngIf="statuses?.length">
    <mat-form-field appearance="outline" class="filter_field">
        <mat-label>Статус</mat-label>
        <mat-select (selectionChange)="applyFilter()" [(ngModel)]="choosenStatus" [disabled]="loading" panelClass="panel_width">
            <mat-option>Все статусы</mat-option>
            <mat-option *ngFor="let status of statuses" [value]="status">{{status}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="spacer"></div>
    </ng-container>

    <ng-container *ngIf="dates?.length">
    <mat-form-field appearance="outline" class="filter_field">
        <mat-label>Даты</mat-label>
        <mat-select (selectionChange)="applyFilter()" [(ngModel)]="choosenDate" [disabled]="loading" panelClass="panel_width">
            <mat-option>За все время</mat-option>
            <mat-option *ngFor="let date of dates" [value]="date">{{date}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="spacer"></div>
    </ng-container>
    

    <div>
        <div>
            @for (limit of viewLimits; track limit.ID){

            <mat-card class="example-card">
                <mat-card-header>
                    <div mat-card-avatar class="example-header-image">

                        @switch (limit.Status) {
                        @case ("новый"){
                        <mat-icon class="redIcon">warning_amber
                        </mat-icon>
                        }
                        @case ("Согласовано") {
                        <mat-icon class="greenIcon">check
                        </mat-icon>

                        }
                        @default {
                        <mat-icon class="orangeIcon">play_arrow
                        </mat-icon>

                        }

                        }



                    </div>
                    <mat-card-title> {{limit.ClientName}} 
                        <mat-card-subtitle>{{limit.BuypointName}}</mat-card-subtitle>
                    </mat-card-title>

                </mat-card-header>
                <mat-card-content style="margin-top: 8px;">

                
                    <p>Статус: <b>{{limit.Status}}</b> </p>
                    <p>Типа запроса: <b>{{limit.Type}}</b></p>
                    <p>
                        @if (limit.AgentName) {
                        {{limit.AgentName}} 
                        }@else {
                        Все агенты
                        }
                    </p>
                    <p>
                        @if (limit.LimitBuypoint){
                        Лимит по ТТ: {{ limit.LimitBuypoint | currency:'RUB':'symbol':'1.2-2':'ru' }}
                        }
                    </p>
                    <p>
                        @if (limit.LimitClient){
                        Лимит по клиенту: {{ limit.LimitClient | currency:'RUB':'symbol':'1.2-2':'ru' }}
                        }
                    </p>
                    <ul>
                        @for (msg of limit.Messages; track msg){
                        <li>
                            <span [innerHTML]="msg"></span>
                        </li>
                        }
                    </ul>

                </mat-card-content>
                <mat-card-actions>
                    @if (limit.BuypointId){
                    <button mat-raised-button [routerLink]="['/clients', limit.BuypointId]" color="primary">
                        перейти к ТТ
                    </button>
                    }
                </mat-card-actions>
            </mat-card>

            }

        </div>